var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-layout-sider",
        {
          staticClass: "mc-left-sider",
          style: _vm.getScrollTop ? _vm.styleObj : {},
          attrs: {
            breakpoint: "lg",
            trigger: null,
            collapsible: "",
            collapsed: _vm.getCollapsed,
            width: "230px"
          }
        },
        [_c("AdminSidebarMenu")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }